// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.glob('./**/*_channel.js', { eager: true })

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import RailsUjs from '@rails/ujs';
import * as ActiveStorage from '@rails/activestorage';

import { Turbo } from '@hotwired/turbo-rails';
import TurboPower from 'turbo_power';

import 'src/aria';
import 'src/confirm';
import 'src/dialog';
import 'src/emitter';
import 'src/stimulus';

TurboPower.initialize(Turbo.StreamActions);
RailsUjs.start();
ActiveStorage.start();
